// extracted by mini-css-extract-plugin
export default {"inner":"styles_inner__YJRjE","title":"styles_title__R4lGJ","kaspiStatus":"styles_kaspiStatus__lHaAk"};